import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Thông báo lỗi đọc được cho người dùng. Lỗi Supabase (PostgrestError, lỗi RPC
 * `raise exception`) KHÔNG phải `instanceof Error` nhưng có `.message` — trước đây
 * bị nuốt thành câu chung chung (VD từ chối đơn nghỉ đã huỷ chỉ báo "Không xử lý được đơn").
 */
export function errorText(e: unknown, fallback: string): string {
  if (e instanceof Error && e.message) return e.message
  const m = (e as { message?: unknown } | null)?.message
  return typeof m === 'string' && m.trim() ? m : fallback
}

/** Chuyển CCCD thành email kỹ thuật để dùng với Supabase Auth */
export const cccdToEmail = (cccd: string) => `${cccd}@v75.local`

/** Validate CCCD: 9 đến 12 chữ số */
export const isValidCccd = (cccd: string) => /^[0-9]{9,12}$/.test(cccd)

/** Format VNĐ đầy đủ, vd 1.234.567 ₫ */
export const fmtVND = (n: number) =>
  new Intl.NumberFormat('vi-VN', { maximumFractionDigits: 0 }).format(n) + ' ₫'

/** Format VNĐ rút gọn cho KPI/biểu đồ, vd 1,2 tỷ · 3,5 tr · 500k */
export const fmtVNDShort = (n: number): string => {
  const abs = Math.abs(n)
  if (abs >= 1_000_000_000) return (n / 1_000_000_000).toFixed(1) + ' tỷ'
  if (abs >= 1_000_000)     return (n / 1_000_000).toFixed(1) + ' tr'
  if (abs >= 1_000)         return Math.round(n / 1_000) + 'k'
  return String(Math.round(n))
}

export const formatDateTime = (d: string | Date) =>
  new Intl.DateTimeFormat('vi-VN', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(d))
